import { all } from 'redux-saga/effects';
import { setLevel } from './sagas/saga'

export default function* rootSaga() {
    yield all([
        setLevel(),
    ]);
}